module.exports = __webpack_public_path__ + "img/leavedates-whoop-strapline-horizontal.4e24e751.svg";